<template>
  <BaseNotification
    type="warning"
    layout="inline"
  >
    <div class="font-semibold mb-5 mt-px">
      Maximum capacity exceeded
    </div>
    {{ message }}
  </BaseNotification>
</template>

<script>
import BaseNotification from '@/components/Ui/BaseNotification.vue';

export default {
  name: 'CapacityExceededBanner',
  components: { BaseNotification },
  computed: {
    capacity() {
      return this.$store.state.room.capacity;
    },
    message() {
      const beginning = 'For safety reasons, this room cannot host more than ';
      if (this.capacity.standing && this.capacity.sitting) {
        return `${beginning} ${this.capacity.standing} people standing or ${this.capacity.sitting} people sitting.`;
      }
      if (!this.capacity.standing) {
        return `${beginning} ${this.capacity.sitting} people sitting.`;
      }
      return `${beginning} ${this.capacity.standing} people standing.`;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
